import React, { useMemo } from "react";
import { Picker } from "@design-system/Picker/Picker.lib";

interface YearSelectProps {
    value: number; // 0 means "All time"
    availableYears: number[];
    onChange: (year: number) => void;
    disabled?: boolean;
}

const ALL_TIME_LABEL = "All time";

export const YearSelect: React.FC<YearSelectProps> = ({
    value,
    availableYears,
    onChange,
    disabled,
}) => {
    const showAllTime = availableYears.length > 1;

    const yearItems = useMemo(
        () => [
            ...(showAllTime ? [{ value: 0, label: ALL_TIME_LABEL }] : []),
            ...availableYears.map((year) => ({
                value: year,
                label: String(year),
            })),
        ],
        [availableYears, showAllTime],
    );

    return (
        <Picker.Select
            items={yearItems}
            value={value}
            onValueChange={(v) => onChange(v ?? 0)}
            renderValue={() => (value === 0 ? ALL_TIME_LABEL : String(value))}
            disabled={disabled}
        />
    );
};
